module.exports = __webpack_public_path__ + "img/delete.7e6ef0e5.svg";